import React from 'react';
import { createRoot  } from 'react-dom/client';

import { Provider } from 'react-redux';
import 'antd/dist/antd.css';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {  Route, Switch , BrowserRouter} from 'react-router-dom';
//import {  Route, Switch , Router} from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import  './utility/extensions';
import { rootUri } from './config/urls';
import { store, history} from './store/store';

let appContainer = document.getElementById('root');
const appRoot = createRoot(appContainer);

appRoot.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Switch>
                <Route path={rootUri} component={App} />
            </Switch>
        </ConnectedRouter>  
    </Provider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
